import React from 'react'
import { FaChartLine } from 'react-icons/fa'
import styled from 'styled-components'
import { Line } from 'react-chartjs-2'

const StepCard = styled.div`
  background: #2a2a2a;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

const StepHeader = styled.div<{ $gradient: string }>`
  background: ${(props) => props.$gradient};
  padding: 0.75rem 1rem;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    width: 18px;
    height: 18px;
  }
`

const StepContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;

  &.chart-content {
    padding: 0.5rem;
  }
`

const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 140px;
  max-height: 160px;

  canvas {
    width: 100% !important;
    height: 100% !important;
  }
`

export interface ChartData {
  labels: string[]
  datasets: Array<{
    label: string
    data: number[]
    borderColor: string
    backgroundColor: string
    tension: number
  }>
}

export interface ChartOptions {
  responsive: boolean
  maintainAspectRatio: boolean
  layout: {
    padding: {
      top: number
      right: number
      bottom: number
      left: number
    }
  }
  scales: {
    y: {
      type: 'linear'
      beginAtZero: boolean
      max: number
      grid: { color: string }
      ticks: {
        color: string
        callback: (value: number | string) => string
      }
    }
    x: {
      type: 'category'
      grid: { display: boolean }
      ticks: { color: string }
    }
  }
  plugins: {
    legend: {
      labels: {
        color: string
        padding: number
        font: { size: number }
      }
      align: 'end'
    }
  }
}

interface MetricProgressCardProps {
  title: string
  gradient: string
  data: ChartData
  options: ChartOptions
}

const MetricProgressCard: React.FC<MetricProgressCardProps> = ({
  title,
  gradient,
  data,
  options,
}) => {
  return (
    <StepCard>
      <StepHeader $gradient={gradient}>
        {title}
        <FaChartLine />
      </StepHeader>
      <StepContent className="chart-content">
        <ChartContainer>
          <Line data={data} options={options} />
        </ChartContainer>
      </StepContent>
    </StepCard>
  )
}

export default MetricProgressCard
